import { FC } from "react";
import { Stack } from "@mui/material";
import { WidgetConfigSection } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/widget-configurations/WidgetConfigSection";
import AdvancedSettingsIcon from "@/assets/icons/app-related/advanced_settings_icon.svg";
import { NormalizedCostWidgetForecastSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/advanced-settings/NormalizedCostWidgetForecastSelect";
import { NormalizedCostWidgetTrendSetting } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/normalized-cost-widget/side-bar/advanced-settings/NormalizedCostWidgetTrendSetting";

export const NormalizedCostWidgetAdvancedSettingsSection: FC = () => {
  return (
    <WidgetConfigSection
      title="Advanced Settings"
      icon={<img src={AdvancedSettingsIcon} alt="Advanced Settings Icon" />}
    >
      <Stack spacing={1.5}>
        <NormalizedCostWidgetForecastSelect />
        <NormalizedCostWidgetTrendSetting />
      </Stack>
    </WidgetConfigSection>
  );
};
